// Store Configuration
// Set STORE_OPEN to false to disable purchasing while keeping the site browsable

export const STORE_CONFIG = {
  // Set to false to pause all purchasing
  STORE_OPEN: false,
  
  // Message shown when store is paused
  PAUSED_MESSAGE: "We're currently updating our store. Browsing is available, but purchasing is temporarily paused. Check back soon!",
  
  // Short message for buttons
  PAUSED_BUTTON_TEXT: "Store Temporarily Closed"
};
